import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import { getTransactionRevenueArrangementDetails } from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";

import RevenueArrangementRevenueElements from "./revenue-arrangement/revenue-elements";
import RevenueArrangementCommunication from "./revenue-arrangement/communication";
import RevenueArrangementRelatedRecords from "./revenue-arrangement/related-records";
import RevenueArrangementSystemInformation from "./revenue-arrangement/system-information";
import RevenueArrangementCustom from "./revenue-arrangement/custom";
import RevenueArrangementEft from"./revenue-arrangement/eft";
import { GridComp4, GridComp12 } from "../../components/GridComponents";
import { CustomCheckBox } from "../../components/CheckboxComp";

export default function TransactionTypeRevenueArrangement() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionRevenueArrangementDetailsData();
    }
  }, []);

  async function getTransactionRevenueArrangementDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionRevenueArrangementDetails(
        user.token,
        {
          tranid: params.docNo,
        }
      );
      setRowData(data.data.details[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return loading ? (
    <>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
          
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      {/*Primary Information*/}
       <Typography component="h4" fontWeight={500} className="pageTitle">
       Revenue Arrangement
            </Typography>
     
           <Typography component="h4" style={{ marginBottom: 5 }}>
              <span className="para-no"  style={{ marginRight: 4 }}><strong>{rowData.tranid}</strong> {rowData.customer}</span>
      </Typography>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
            <>
              <Grid container className="mb-2">
                <GridComp4
                  title={"REVENUE ARRANGEMENT #"}
                  data={rowData.revenue_arrangement_number}
                />
                <CustomCheckBox
                  title={"MERGED INTO NEW ARRANGEMENTS"}
                  data={rowData.merged_into_new_arrangements}
                />
                <GridComp4
                  title={"TRANSACTION TOTAL"}
                  data={rowData.transaction_total}
                />
                <GridComp4 title={"CUSTOMER"} data={rowData.customer} />
                <GridComp4
                  title={"REVENUE PLAN STATUS"}
                  data={rowData.revenue_plan_status}
                />
                <GridComp4 title={"TOTAL CARVE-OUT"} data={rowData.total_carve_out} />
                <GridComp4  />

               
                <CustomCheckBox title={"COMPLIANT"} data={rowData.compliant} />
                <GridComp4
                  title={"TOTAL REVENUE AMOUNT"}
                  data={rowData.total_revenue_amount}
                />
                 <GridComp4  />
                <CustomCheckBox
                  title={"TRANSACTION IS ALLOCATION BUNDLE"}
                  data={rowData.transaction_is_allocation_bundle}
                />
                <GridComp4  />
          
                <GridComp4 title={"DATE"} data={rowData.date} />
    
                <CustomCheckBox
                  title={"CREATED FROM MERGED ARRANGEMENTS"}
                  data={rowData.created_from_merged_arrangements}
                />
                <GridComp4 title={"MEMO"} data={rowData.memo} />
              </Grid>
            </>
          {/* ))} */}
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
            <>
              <Grid container className="mb-2">
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">SUBSIDIARY</p>
                <p className="tFormName">{rowData.subsidiary}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">DEPARTMENT</p>
                <p className="tFormName">{rowData.department}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">SERVICE LINE</p>
                <p className="tFormName">{rowData.service_line}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">CURRENCY</p>
                <p className="tFormName">{rowData.currency}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">LOCATION</p>
                <p className="tFormName">{rowData.location}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">INVOICE MESSAGING</p>
                <p className="tFormName">{rowData.invoice_messaging}</p>
              </Grid>
              <CustomCheckBox
                  title={"IS SELLER IMPORTER RECORD"}
                  data={rowData.is_seller_importer_record}
                />
                <Grid item xs={12} sm={12} md={12} className="m-b-10">
                  <p className="tFormlabel">SHIP-TO ENTITY/USE CODE</p>
                  <p className="tFormName">{rowData.custbody_ava_shiptousecode}</p>
                </Grid>
                <Grid item xs={12} sm={12} md={12} className="m-b-10">
                <p className="tFormlabel">BILL-TO ENTITY/USE CODE</p>
                <p className="tFormName">{rowData.custbody_ava_shiptousecode}</p>
                </Grid>
              </Grid>
            </>
          {/* ))} */}
        </Box>
      </Box>

      <Box>
        <Box
          className="viewBox "
          // sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg tabs-spacing"
          >
            <Tab label="Revenue Elements" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
          </Tabs>

          {/* Revenue Elements */}
          <TabPanel value={tabIndex} index={0}>
          {tabIndex === 0 && <RevenueArrangementRevenueElements />}
          </TabPanel>
          {/* Revenue Elements */}

          {/* Communication */}
          <TabPanel value={tabIndex} index={1}>
          {tabIndex === 1 && <RevenueArrangementCommunication tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Communication */}

          {/* RelatedRecords */}
          <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && (
              <RevenueArrangementRelatedRecords tabIndexP={tabIndex} />
            )}
          </TabPanel>
          {/* RelatedRecords */}

          {/* SystemInformation */}
          <TabPanel value={tabIndex} index={3}>
          {tabIndex === 3 &&  <RevenueArrangementSystemInformation tabIndexP={tabIndex} />}
          </TabPanel>
          {/* SystemInformation */}

          {/* Custom */}
          <TabPanel value={tabIndex} index={4}>
          {tabIndex === 4 && <RevenueArrangementCustom tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Eft */}
          <TabPanel value={tabIndex} index={5}>
          {tabIndex === 5 &&  <RevenueArrangementEft tabIndexP={tabIndex} />}
          </TabPanel>
          
        </Box>
      </Box>
    </>
  );
}
